module.exports = __webpack_public_path__ + "static/media/za.177080d3.svg";